var React = require('react');

function Bitbucket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":" M 0.649 0 C 0.46 -0.003 0.279 0.079 0.155 0.222 C 0.032 0.365 -0.022 0.556 0.008 0.743 L 2.729 17.257 C 2.798 17.674 3.158 17.98 3.581 17.984 L 16.631 17.984 C 16.948 17.988 17.221 17.759 17.272 17.446 L 19.992 0.746 C 20.022 0.56 19.968 0.369 19.845 0.225 C 19.721 0.082 19.54 0.001 19.351 0.003 L 0.649 0 Z  M 12.104 11.935 L 7.938 11.935 L 6.81 6.043 L 13.113 6.043 L 12.104 11.935 Z "}));
}

Bitbucket.defaultProps = {"style":{"isolation":"isolate"},"viewBox":"0 0 20 17.984","width":"20pt","height":"17.984pt"};

module.exports = Bitbucket;

Bitbucket.default = Bitbucket;
